import Component from './LocalizedButton.component';
import { connect } from 'react-redux';
import fromState from '../../state/selectors';

export const mapStateToProps = state => ({
    shouldRetranslate: fromState.Locale.shouldRetranslate(state),
});

/** @type {React.ForwardRefExoticComponent<import('@mui/material').ButtonProps & Omit<import('./LocalizedButton.component').LocalizedButtonProps,keyof ReturnType<mapStateToProps>>} */
export default connect(mapStateToProps, {}, null, { forwardRef: true })(Component);
